import { apiFetch } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

export const riskAssessmentsApi = {
  ...createWorkspaceResourceApi('risk-assessments'),
  report: (workspaceId, id) => apiFetch(`workspaces/${workspaceId}/risk-assessments/${id}/report`),
  setStatus: (workspaceId, id, status) =>
    apiFetch(`workspaces/${workspaceId}/risk-assessments/${id}/progress/${status}`, { method: 'POST' }),
  products: (workspaceId, params, { signal } = {}) =>
    apiFetch(`workspaces/${workspaceId}/workspace-products`, { params, signal }),
}

export const riskAssessmentTypesApi = createWorkspaceResourceApi('risk-assessment-types')
export const riskAssessmentCategoriesApi = createWorkspaceResourceApi('risk-assessment-categories')
